import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { PermissionStates } from '../../modules/permission/permission-controller/root';
import { UserPermInquirySelectors } from '../../modules/permission/user-permissions-inquiry-controller/selectors';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { DropDownService } from '../../services/drop-down-service';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-select-multi-drop-down',
  templateUrl: './select-multi-drop-down.component.html',
  styleUrls: ['./select-multi-drop-down.component.css']
})
export class SelectMultiDropDownComponent implements OnInit, OnDestroy {

  @Input() form: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() label = '';
  @Input() key: any;
  @Input() options: any;
  @Input() defaultRows: any = [];

  @Output() formSelected = new EventEmitter<any>();

  userPermissionTarget$ = this.permissionStore.select(
    UserPermInquirySelectors.selectUserPermInquiry
  );
  
  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  filteredCache: any = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  protected _onDestroy = new Subject<void>();

  constructor(private dropDownService: DropDownService,
    private readonly store: Store<SessionStates>,
    private readonly permissionStore: Store<PermissionStates>
  ) { 
  }

  ngOnInit() {
    // set initial selection
    if (this.defaultRows.length > 0) {
      this.rowData = [...this.rowData, ...this.defaultRows];
      this.filteredOptions$.next(this.defaultRows.slice());
    }

    if (this.key) {
      this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
        this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
        if (this.rowData.length === 0) {
          this.getRowData();
        }
        else {
          this.filteredOptions$.next(this.rowData.slice());
        }
      })
    }
    
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
        this.setToggleAllCheckboxState();
      });

    // listen for multi select field value changes
    this.form.valueChanges
      .pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.setToggleAllCheckboxState();
      }); 
  }

  ngOnChanges() {
    //console.log('ngOnChanges');
  }

  getRowData() {
    let formData = {
      "limit" : null,
      "orderBy" : "code",
      "order" : "ASC"
    }
    this.dropDownService.get(this.key + '/backoffice-ep', formData, this.apiVisa).subscribe(resolved => {
      //console.log(resolved.data);
      this.rowData = resolved.data;
      this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));      
      //fill the drop down
      this.filteredOptions$.next(this.rowData.slice());
    });
  }

  
  filtering() {
    if (!this.rowData) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredCache = this.rowData.slice();
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter
    this.filteredCache = this.rowData.filter((option) =>
    (option.code ?
      option.code.toLowerCase().indexOf(search) > -1 : null) ||
    (option.name ?
      option.name.toLowerCase().indexOf(search) > -1 : null));

    this.filteredOptions$.next(this.filteredCache);
  }

  onSelect(guid: string) {
    if (guid) {
      this.form.patchValue(guid);
      this.selectedRow = this.rowData.find(row => row.guid === guid);
      this.formSelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false; 
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredOptions$.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.form.patchValue([...val.map(item => item.guid)]);
        } else {
          this.form.patchValue([]);
        }
      }
    );
  }

  setToggleAllCheckboxState() {
    if (!this.isMultiple()) return;
    let filteredLength = 0;
    if (this.form && this.form.value) {
      this.filteredCache.forEach(el => {
        if (this.form.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    }
  }

  displayRow(code, name) {
    return code + (name? ' | ' + name : ''); 
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
